export default __webpack_public_path__ + "static/media/thumbnail.35555251.png";